import Keycloak from 'keycloak-js'
import axios from 'axios'
import store from '@/store'
import devicePush from '@/services/device-push'

const authProvider = new Keycloak({
  realm: `${process.env.KEYCLOAK_REALM}`,
  url: `${process.env.KEYCLOAK_URL}`,
  clientId: `${process.env.KEYCLOAK_CLIENT_ID}`,
})

const api = {
  authenticate(to, from, next) {
    /* eslint-disable func-names */
    authProvider.init({ onLoad: 'login-required', adapter: 'default', checkLoginIframe: false })
      .then(() => {})
      .catch((() => {}))

    const that = this

    authProvider.onAuthSuccess = function() {
      authProvider.loadUserProfile().then((result) => {
        store.commit('auth/set', { type: 'authenticated', value: true })
        store.commit('auth/set', { type: 'keycloak', value: authProvider })

        const profile = {
          userName: result.username,
          firstName: result.firstName,
          lastName: result.lastName,
          email: result.email ? result.email : result.username,
          attributes: result.attributes,
        }
        if (result.attributes && result.attributes.telephoneNumber && result.attributes.telephoneNumber[0]) {
          profile.phone = result.attributes.telephoneNumber[0]
        }
        if (result.attributes && result.attributes.thumbnailPhoto && result.attributes.thumbnailPhoto[0]) {
          profile.photo = result.attributes.thumbnailPhoto[0]
        }
        store.commit('auth/set', { type: 'profile', value: profile })

        const updateTokenInterval = setInterval(() => authProvider.updateToken(120), 1000 * 60)
        store.commit('auth/set', { type: 'updateTokenInterval', value: updateTokenInterval })

        axios.defaults.headers.common.Authorization = `Bearer ${store.getters['auth/keycloak'].token}`

        store.dispatch('auth/getGroups').then(() => {
          // Если есть группы то пользователь существует в БД (как минимум группа USER) пропускаем его дальше
          if (store.getters['auth/groups'].length > 0) {
            if (window.cordova !== undefined) {
              devicePush.getTokenAndSubscribe() // Cordova push notifications
            }
            // Если есть проверка на авторизацию по группе
            if (to.meta.groups) {
              that.checkGroupPermission(to, from, next)
            } else {
              next()
            }
          } else {
            // Инициализация пользователя если его нету в Camunda но есть в Keycloak
            const initializeUser = {
              userName: result.username,
              firstName: result.firstName,
              lastName: result.lastName,
              email: result.email,
            }
            store.dispatch('auth/initializeUser', initializeUser).then(() => {
              location.reload()
            }).catch((error) => {
              store.dispatch('tools/setSnackbar', `Произошла ошибка при инициализации пользователя: ${error}`)
            })
          }
        })
      }).catch((errorData) => {
        store.dispatch('tools/setSnackbar', `Произошла ошибка при попытке получить профайл: ${JSON.stringify(errorData)}`)
      })
    }

    authProvider.onAuthRefreshSuccess = function() {
      store.commit('auth/set', { type: 'keycloak', value: authProvider })
      axios.defaults.headers.common.Authorization = `Bearer ${store.getters['auth/keycloak'].token}`
    }

    authProvider.onAuthRefreshError = function(error) {
      store.dispatch('tools/setSnackbar', `Произошла ошибка при попытке обновить токен: ${JSON.stringify(error)}`)
      this.init()
    }

    authProvider.onAuthError = function(error) {
      store.dispatch('tools/setSnackbar', `Произошла ошибка при попытке аутентификации: ${JSON.stringify(error)}`)
      this.init()
    }
  },

  checkGroupPermission(to, from, next) {
    const groups = store.getters['auth/groups']
    const hasRole = groups.some(r => to.meta.groups.indexOf(r.id) >= 0)
    if (hasRole) {
      next()
    } else {
      store.dispatch('tools/setSnackbar', 'У Вас нет доступа на данную страницу')
      next('/task-list')
    }
  },
}

export default api



// WEBPACK FOOTER //
// ./src/services/auth.js